import type { ReactNode } from 'react';

interface SectionCardProps {
  title?: ReactNode;
  extra?: ReactNode;
  children?: ReactNode;
  flush?: boolean;
}

export function SectionCard({ title, extra, children, flush }: SectionCardProps) {
  return (
    <div className="mp-card">
      {title ? (
        <div className="mp-card__head">
          <h4 className="mp-card__title">{title}</h4>
          {extra ? <div className="mp-card__extra">{extra}</div> : null}
        </div>
      ) : null}
      <div className={'mp-card__body' + (flush ? ' mp-card__body--flush' : '')}>{children}</div>
    </div>
  );
}
